<template>
  <div class="dataUlasan">
    <div class="p-x-16 p-t-16">
      <p class="f-Overpass f-16 f-c-black f-bold">Ulasan</p>
    </div>
    <div>
      <ol :start="'1'" class="remove-margin">
        <li class="f-14 f-Overpass f-c-midgrey">
          Apakah penjelasan trainer informatif bagi user?
        </li>
      </ol>

      <div class="p-t-8 paddingText">
        <star-rating
          :rating="rating1"
          :show-rating="false"
          :star-size="20"
          :padding="5"
          :read-only="true"
        />
      </div>
    </div>
    <div class="p-t-16">
      <ol :start="'2'" class="remove-margin">
        <li class="f-14 f-Overpass f-c-midgrey">
          Apakah penjelasan trainer sesuai dengan kebutuhan user?
        </li>
      </ol>

      <div class="p-t-8 paddingText">
        <star-rating
          :rating="rating2"
          :show-rating="false"
          :star-size="20"
          :padding="5"
          :read-only="true"
        />
      </div>
    </div>
    <div class="p-t-16">
      <ol :start="'3'" class="remove-margin">
        <li class="f-14 f-Overpass f-c-midgrey">
          Bagaimana menurut Anda atas solusi yang diberikan trainer untuk
          pertanyaan anda?
        </li>
      </ol>
      <p class="f-16 f-Overpass p-t-8 paddingText">{{ ulasan1 }}</p>
    </div>
    <div>
      <ol :start="'4'" class="remove-margin">
        <li class="f-14 f-Overpass f-c-midgrey">
          Kritik dan saran Anda terhadap aplikasi kami?
        </li>
      </ol>
      <p class="f-16 f-Overpass p-t-8 paddingText">{{ ulasan2 }}</p>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";

export default {
  name: "DataUlasan",
  components: {
    StarRating,
  },
  props: {
    rating_1: Number,
    rating_2: Number,
    ulasan_1: "",
    ulasan_2: "",
  },
  data() {
    return {
      rating1: this.rating_1,
      rating2: this.rating_2,
      ulasan1: this.ulasan_1,
      ulasan2: this.ulasan_2,
    };
  },
};
</script>

<style scoped>
.paddingText {
  padding-left: 40px;
  padding-right: 20px;
}
</style>
